const isProd = process.env.NODE_ENV === "production";

export const beeXLogger = {
  log: (...args) => {
    console.log("%c[LOG]", "color:#3498db", ...args);
  },
  info: (...args) => {
    if (!isProd) console.info("%c[INFO]", "color:#2ecc71", ...args);
  },
  warn: (...args) => {
    if (!isProd) console.warn("%c[WARN]", "color:#f39c12", ...args);
  },
  error: (...args) => {
    if (!isProd) console.error("%c[ERROR]", "color:#e74c3c", ...args);
  },
  debug: (...args) => {
    if (!isProd)
      console.log("%c[DEBUG]", "color:#8e44ad", ...args);
  }
};
